/* V1.13 · Assistant IA du site (section mp-chat) : panneau de discussion, message automatique sur les fiches produit
   (une fois par visite), relais vers l'equipe par le formulaire de contact Shopify.
   La conversation est gardee dans sessionStorage : elle suit le client de page en page pendant la visite. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mp-chat]');
  if (!root || root.__mpChat) return;
  root.__mpChat = true;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-mp-chat-config]').textContent); } catch (e) {}
  var endpoint = cfg.endpoint || window.__mpChatTestEndpoint || '';
  if (!endpoint) return;
  root.hidden = false;

  var KEY = 'mpChat:v1';
  var NUDGED = 'mpChat:nudged';
  var T = cfg.text || {};
  var $ = function (sel) { return root.querySelector(sel); };
  var panel = $('[data-mp-chat-panel]');
  var log = $('[data-mp-chat-log]');
  var chipsBox = $('[data-mp-chat-chips]');
  var form = $('[data-mp-chat-form]');
  var input = $('[data-mp-chat-input]');
  var sendBtn = $('[data-mp-chat-send]');
  var toggle = $('[data-mp-chat-toggle]');
  var badge = $('[data-mp-chat-badge]');
  var nudge = $('[data-mp-chat-nudge]');
  var busy = false;

  function load(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
  function keep(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var state = load(KEY) || { messages: [], opened: false };
  function save() { keep(KEY, { messages: state.messages.slice(-40), opened: state.opened }); }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  // ligne de contexte jointe a chaque message du client (date du jour + page consultee)
  function ctxLine() {
    var d = new Date();
    var page = cfg.product
      ? 'product "' + cfg.product.title + '" (' + cfg.product.handle + ')'
      : (cfg.pageType || 'page') + ' ' + location.pathname;
    return '[Today: ' + d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' | Page: ' + page + ']';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  // texte de l'assistant -> HTML : liens [texte](url) internes ou https, **gras**, listes « - », paragraphes
  function format(text) {
    var html = esc(text)
      .replace(/\[([^\]]+)\]\(((?:\/|https:\/\/)[^\s)]+)\)/g, function (m, label, url) {
        var ext = /^https:\/\//.test(url) && url.indexOf(location.host) === -1;
        return '<a href="' + url + '"' + (ext ? ' target="_blank" rel="noopener"' : '') + '>' + label + '</a>';
      })
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    // paragraphes separes par une ligne vide ; dans un paragraphe, les lignes « - » qui se suivent deviennent une liste
    return html.split(/\n{2,}/).map(function (block) {
      var out = '';
      var text = [];
      var items = [];
      function flushText() { if (text.length) out += '<p>' + text.join('<br>') + '</p>'; text = []; }
      function flushList() { if (items.length) out += '<ul>' + items.map(function (i) { return '<li>' + i + '</li>'; }).join('') + '</ul>'; items = []; }
      block.split('\n').forEach(function (l) {
        if (/^\s*[-•]\s+/.test(l)) { flushText(); items.push(l.replace(/^\s*[-•]\s+/, '')); }
        else { flushList(); text.push(l); }
      });
      flushText();
      flushList();
      return out;
    }).join('');
  }

  function scrollDown() { log.scrollTop = log.scrollHeight; }

  function bubble(m) {
    var el = document.createElement('div');
    el.className = 'mp-chat__msg ' + (m.role === 'user' ? 'mp-chat__msg--user' : m.note ? 'mp-chat__msg--note' : 'mp-chat__msg--bot');
    if (m.role === 'user') el.textContent = m.text;
    else el.innerHTML = format(m.text);
    if (m.mailto) {
      var a = document.createElement('a');
      a.className = 'mp-chat__mail';
      a.href = m.mailto;
      a.textContent = T.emailButton || 'Email the team';
      el.appendChild(a);
    }
    log.appendChild(el);
    if (m.products && m.products.length) {
      var row = document.createElement('div');
      row.className = 'mp-chat__cards';
      m.products.forEach(function (p) {
        var c = document.createElement('a');
        c.className = 'mp-chat__card';
        c.href = p.url;
        c.innerHTML = (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="52" height="66">' : '') +
          '<span><p class="mp-chat__card-title">' + esc(p.title) + '</p><p class="mp-chat__card-price">' + esc(p.price || '') +
          (p.compare_at_price ? '<s>' + esc(p.compare_at_price) + '</s>' : '') + '</p></span>';
        row.appendChild(c);
      });
      log.appendChild(row);
    }
  }

  function renderChips() {
    chipsBox.innerHTML = '';
    var asked = state.messages.some(function (m) { return m.role === 'user'; });
    if (asked) return;
    (cfg.chips || []).map(function (c) { return c.trim(); }).filter(Boolean).forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mp-chat__chip';
      b.textContent = c;
      b.addEventListener('click', function () { send(c); });
      chipsBox.appendChild(b);
    });
  }

  function render() {
    log.innerHTML = '';
    state.messages.forEach(bubble);
    renderChips();
    scrollDown();
  }

  var typingEl = null;
  function typing(on) {
    if (on && !typingEl) {
      typingEl = document.createElement('div');
      typingEl.className = 'mp-chat__typing';
      typingEl.setAttribute('aria-label', 'Assistant is typing');
      typingEl.innerHTML = '<span></span><span></span><span></span>';
      log.appendChild(typingEl);
      scrollDown();
    } else if (!on && typingEl) {
      typingEl.remove();
      typingEl = null;
    }
  }

  function push(m) {
    state.messages.push(m);
    save();
    bubble(m);
    renderChips();
    scrollDown();
  }

  function open(fromNudge) {
    hideNudge(true);
    if (!state.messages.length && cfg.welcome) state.messages.push({ role: 'assistant', text: cfg.welcome });
    state.opened = true;
    save();
    panel.hidden = false;
    root.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    badge.hidden = true;
    render();
    if (!fromNudge || window.matchMedia('(min-width: 750px)').matches) input.focus({ preventScroll: true });
  }

  function close() {
    panel.hidden = true;
    root.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus({ preventScroll: true });
  }

  function send(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    busy = true;
    sendBtn.disabled = true;
    push({ role: 'user', text: text.slice(0, 1500), ctx: ctxLine() });
    input.value = '';
    grow();
    typing(true);
    var payload = state.messages.filter(function (m) { return !m.local && !m.note; }).map(function (m) {
      return m.role === 'user' ? { role: 'user', text: m.text, ctx: m.ctx } : { role: 'assistant', text: m.text };
    });
    fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: payload }) })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        typing(false);
        if (!data || !data.reply) throw new Error('empty');
        push({ role: 'assistant', text: data.reply, products: (data.products || []).slice(0, 3), local: !!data.error });
        if (data.handoff) handoff(data.handoff);
      })
      .catch(function () {
        typing(false);
        push({ role: 'assistant', local: true, text: (cfg.text && cfg.text.error || 'Sorry, something went wrong. Please try again.').replace('[email]', cfg.contactEmail || '') });
      })
      .then(function () {
        busy = false;
        sendBtn.disabled = false;
      });
  }

  // relais vers l'equipe : vrai formulaire de contact Shopify (hCaptcha de la boutique), envoye dans un cadre invisible
  function handoff(h) {
    var lines = state.messages.filter(function (m) { return !m.note; }).slice(-16).map(function (m) {
      return (m.role === 'user' ? 'Customer: ' : 'Assistant: ') + m.text;
    });
    var body = 'Request from the website assistant\n\nTopic: ' + h.topic + '\nName: ' + (h.name || '-') + '\nEmail: ' + h.email +
      '\nOrder: ' + (h.order_number || '-') + '\nPage: ' + location.href + '\n\nSummary:\n' + h.summary + '\n\nConversation:\n' + lines.join('\n');
    var mailto = 'mailto:' + (cfg.contactEmail || '') + '?subject=' + encodeURIComponent((h.topic || 'Question') + (h.order_number ? ' ' + h.order_number : '')) +
      '&body=' + encodeURIComponent('Summary: ' + h.summary + '\nOrder: ' + (h.order_number || '-') + '\n\n');
    var f = root.querySelector('[data-mp-chat-contact]');
    var fail = function () { push({ role: 'assistant', note: true, local: true, text: T.notSent || 'We couldn’t send it automatically.', mailto: mailto }); };
    if (!f || typeof f.requestSubmit !== 'function') return fail();
    var frame = root.querySelector('iframe[name="mp-chat-frame"]');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.name = 'mp-chat-frame';
      frame.className = 'mp-chat__frame';
      frame.title = 'Contact';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      root.appendChild(frame);
    }
    f.querySelector('[name="contact[name]"]').value = h.name || '';
    f.querySelector('[name="contact[email]"]').value = h.email;
    f.querySelector('[name="contact[Topic]"]').value = h.topic || '';
    f.querySelector('[name="contact[Order]"]').value = h.order_number || '';
    f.querySelector('[name="contact[body]"]').value = body;
    f.setAttribute('target', 'mp-chat-frame');
    // 2 min : le client peut avoir un puzzle hCaptcha a resoudre ; un envoi qui aboutit apres coup est quand meme confirme
    var done = false;
    var sent = false;
    var timer = setTimeout(function () { if (!done) { done = true; fail(); } }, 120000);
    frame.onload = function () {
      var href = '';
      try { href = frame.contentWindow.location.href; } catch (e) {}
      if (sent || !href || href === 'about:blank') return;
      if (href.indexOf('contact_posted=true') > -1) {
        sent = true;
        done = true;
        clearTimeout(timer);
        push({ role: 'assistant', note: true, local: true, text: '✓ ' + (T.sent || 'Sent to our team.').replace('[email]', h.email) });
      } else if (!done) {
        done = true;
        clearTimeout(timer);
        fail();
      }
    };
    // le hCaptcha de Shopify n'arme un formulaire de contact qu'a la premiere interaction (focus ou « change ») et annule
    // l'envoi d'un formulaire non arme : on declenche « change » sur un champ, on attend l'armement (8 s max), puis on envoie
    var field = f.querySelector('[name="contact[email]"]');
    if (!f.dataset.hcaptchaBound && !f.dataset.recaptchaBound && field) field.dispatchEvent(new Event('change', { bubbles: true }));
    var tries = 0;
    (function waitArmed() {
      if (f.dataset.hcaptchaBound || f.dataset.recaptchaBound || tries++ >= 40) return f.requestSubmit();
      setTimeout(waitArmed, 200);
    })();
  }

  // message automatique sur une fiche produit : apres X s de lecture (onglet visible), une fois par visite
  function hideNudge(forGood) {
    nudge.hidden = true;
    if (forGood) keep(NUDGED, true);
  }
  function showNudge() {
    if (state.opened || load(NUDGED) || !panel.hidden) return;
    var text = String(cfg.nudge || '').replace(/\[product\]/g, cfg.product ? cfg.product.title : 'this piece');
    if (!text) return;
    keep(NUDGED, true);
    root.querySelector('[data-mp-chat-nudge-text]').textContent = text;
    nudge.hidden = false;
    badge.hidden = false;
    // le message devient le premier de la conversation, comme s'il venait du chat
    if (!state.messages.length) {
      state.messages.push({ role: 'assistant', text: text });
      save();
    }
  }
  if (cfg.product && !state.opened && !load(NUDGED)) {
    var wait = Math.max(5, Number(cfg.delay) || 25) * 1000;
    var seenMs = 0;
    var last = Date.now();
    var tick = setInterval(function () {
      var now = Date.now();
      if (document.visibilityState === 'visible') seenMs += now - last;
      last = now;
      if (seenMs >= wait) {
        clearInterval(tick);
        showNudge();
      }
    }, 500);
  }

  function grow() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }

  toggle.addEventListener('click', function () { if (panel.hidden) open(false); else close(); });
  $('[data-mp-chat-close]').addEventListener('click', close);
  $('[data-mp-chat-nudge-open]').addEventListener('click', function () { open(true); });
  $('[data-mp-chat-nudge-close]').addEventListener('click', function () { hideNudge(true); badge.hidden = true; });
  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });
  input.addEventListener('input', grow);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(input.value); }
  });
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

  // conversation deja ouverte sur une page precedente de la visite : on la retrouve, panneau ferme
  if (state.messages.length) render();
})();
